import React from 'react';
import { Printer, ArrowLeft } from 'lucide-react';

export default function ExpenseReportToolbar({ onPrint, onBack }) {
  return (
    <div className="no-print sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-4xl mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {onBack && (
            <button 
              onClick={onBack}
              className="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200 transition-all mr-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </button>
          )}
          <span className="font-semibold text-slate-700 text-sm">Expense Report Preview</span>
        </div>
        <div className="flex items-center gap-2">
          <button 
            onClick={onPrint} 
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-orange-600 text-white hover:bg-orange-700 transition-all shadow-sm"
          >
            <Printer className="w-4 h-4" />
            Print / Save PDF
          </button>
        </div>
      </div>
    </div>
  );
}
